module.exports = __webpack_public_path__ + "img/image_10.97748441.jpg";